// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockTitle__M1sON {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  min-height: 20px;
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__cnjYZ {
  padding: 25px;
  display: grid;
  grid-template-columns: 140px 1fr minmax(350px, 450px);
  gap: 25px;
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}
@media (max-width: 1600px) {
  .blockContainer__cnjYZ {
    grid-template-columns: 140px 1fr 320px;
  }
}
@media (max-width: 1400px) {
  .blockContainer__cnjYZ {
    grid-template-columns: 140px 1fr 270px;
  }
}
@media (max-width: 1300px) {
  .blockContainer__cnjYZ {
    grid-template-columns: 140px 1fr 400px;
  }
}
@media (max-width: 999px) {
  .blockContainer__cnjYZ {
    grid-template-columns: 140px 1fr;
  }
}

.extraInfo__Ls7qo {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.replaceBtnWrapper__AjOTx {
  margin-top: auto;
}

.mainInfo__I9I0C {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.infoFields__Hb8R4 {
  display: grid;
  grid-template-columns: auto 70px;
  align-items: flex-start;
  column-gap: 5px;
  row-gap: 15px;
}

.galleryBlock__dPqtW {
  position: relative;
}
@media (max-width: 999px) {
  .galleryBlock__dPqtW {
    grid-area: 2/1/2/3;
  }
}

.copyIcon__Wm2_H {
  width: 16px;
  height: 16px;
}
.copyIcon__Wm2_H path {
  fill: var(--buttons-surface);
}

.linkSensorsList__ELMka {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-text-secondary);
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  display: inline-block;
  margin-top: 7px;
  margin-left: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}

.skeletonBlockContainer__qP4tB div {
  row-gap: 25px;
}

.skeletonSquare__I1kou {
  height: 120px;
}

.skeletonText__u97z7 {
  height: 24px;
}

.skeletonGallery__re96v {
  height: 380px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorDetails/components/SensorInformation/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,aAAA;EACA,qDAAA;EACA,SAAA;EACA,2DAAA;EACA,wCAAA;AAzEF;AA2EE;EARF;IASI,sCAAA;EAxEF;AACF;AA0EE;EAZF;IAaI,sCAAA;EAvEF;AACF;AAyEE;EAhBF;IAiBI,sCAAA;EAtEF;AACF;AAwEE;EApBF;IAqBI,gCAAA;EArEF;AACF;;AAwEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AArEF;;AAwEA;EACE,gBAAA;AArEF;;AAwEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AArEF;;AAwEA;EACE,aAAA;EACA,gCAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AArEF;;AAwEA;EACE,kBAAA;AArEF;AAsEE;EAFF;IAGI,kBAAA;EAnEF;AACF;;AAsEA;EACE,WAAA;EACA,YAAA;AAnEF;AAqEE;EACE,4BAAA;AAnEJ;;AAuEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AApEF;;AAwEE;EACE,aAAA;AArEJ;;AAyEA;EACE,aAAA;AAtEF;;AAyEA;EACE,YAAA;AAtEF;;AAyEA;EACE,aAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  padding: 25px;\n  display: grid;\n  grid-template-columns: 140px 1fr minmax(350px, 450px);\n  gap: 25px;\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n\n  @media (max-width: 1600px) {\n    grid-template-columns: 140px 1fr 320px;\n  }\n\n  @media (max-width: 1400px) {\n    grid-template-columns: 140px 1fr 270px;\n  }\n\n  @media (max-width: 1300px) {\n    grid-template-columns: 140px 1fr 400px;\n  }\n\n  @media (max-width: 999px) {\n    grid-template-columns: 140px 1fr;\n  }\n}\n\n.extraInfo {\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n}\n\n.replaceBtnWrapper {\n  margin-top: auto;\n}\n\n.mainInfo {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.infoFields {\n  display: grid;\n  grid-template-columns: auto 70px;\n  align-items: flex-start;\n  column-gap: 5px;\n  row-gap: 15px;\n}\n\n.galleryBlock {\n  position: relative;\n  @media (max-width: 999px) {\n    grid-area: 2 / 1 / 2 / 3;\n  }\n}\n\n.copyIcon {\n  width: 16px;\n  height: 16px;\n\n  path {\n    fill: var(--buttons-surface);\n  }\n}\n\n.linkSensorsList {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-text-secondary);\n  text-transform: uppercase;\n  text-decoration: none;\n  white-space: nowrap;\n  display: inline-block;\n  margin-top: 7px;\n  margin-left: auto;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.skeletonBlockContainer {\n  div {\n    row-gap: 25px;\n  }\n}\n\n.skeletonSquare {\n  height: 120px;\n}\n\n.skeletonText {\n  height: 24px;\n}\n\n.skeletonGallery {\n  height: 380px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockTitle": `blockTitle__M1sON`,
	"blockContainer": `blockContainer__cnjYZ`,
	"extraInfo": `extraInfo__Ls7qo`,
	"replaceBtnWrapper": `replaceBtnWrapper__AjOTx`,
	"mainInfo": `mainInfo__I9I0C`,
	"infoFields": `infoFields__Hb8R4`,
	"galleryBlock": `galleryBlock__dPqtW`,
	"copyIcon": `copyIcon__Wm2_H`,
	"linkSensorsList": `linkSensorsList__ELMka`,
	"skeletonBlockContainer": `skeletonBlockContainer__qP4tB`,
	"skeletonSquare": `skeletonSquare__I1kou`,
	"skeletonText": `skeletonText__u97z7`,
	"skeletonGallery": `skeletonGallery__re96v`
};
module.exports = ___CSS_LOADER_EXPORT___;
